import { motion } from "framer-motion";

export const SectionLabel = ({ children, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className="w-8 h-px bg-gold" />
    <span className="text-[10px] uppercase tracking-editorial text-charcoal/60">{children}</span>
  </div>
);

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ y: 28, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const HeroReveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ y: 40, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Stat = ({ value, label }) => (
  <div className="text-center">
    <div className="font-serif text-5xl md:text-6xl font-light text-teal">{value}</div>
    <div className="text-[10px] uppercase tracking-editorial text-charcoal/55 mt-2">{label}</div>
  </div>
);
